import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import firebase from 'firebase'
function SetUserId(props) {
    const [show, setShow] = useState(props.show);
    const [user, setUser] = useState({})
    const [id, setId] = useState(user !== null ? user.uid : 'user')
    const [listPaths, setListPaths] = useState([])
    const [doesIdExist, setdoesIdExist] = useState(false)
    const [isValidId, setIsValidId] = useState(false)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    useEffect(() => {
        let isSubscribed = true

        firebase.auth().onAuthStateChanged(User => {
            if (isSubscribed) {
                setUser(User)
            }
        })
        return () => { isSubscribed = false }
    })
    useEffect(() => {
        let isSubscribed = true
        if (user !== null) {
            firebase.database().ref().get().then(
                s => {
                    if (s.val() !== null) {
                        if (isSubscribed) { setListPaths(Object.keys(s.val())) }
                    }
                }
            )
        }
        return () => { isSubscribed = false }

    }, [user]
    )
    const onchange = e => {
        let x = e.target.value.toString()
        x = x.toLowerCase()
        x = x.toString().replace(/[^a-zA-Z0-9_-]/g, '')
        x = x.replaceAll(' ', '')
        setId(x)
        if (listPaths.includes(x) || x == 'admin' || x == 'signin' || x == 'signup') {
            setdoesIdExist(true)
            setIsValidId(false)
        }
        else if (x === '' || x.length < 5) {
            setIsValidId(false)
            setdoesIdExist(false)
        }
        else {
            setdoesIdExist(false)
            setIsValidId(true)
        }
    }

    const submit = e => {
        e.preventDefault()
        if (user.uid !== null) {
            firebase.database().ref('users').child(user.uid).child('linkid').set(id)
            firebase.database().ref(id).child('background').set('default')
            firebase.database().ref(id).child('user').set(user.uid).then(
                () => window.location.reload()
            )

        }
    }
    return (
        <>
            <Modal
                style={{ background: "rgba(0,0,0,0.4)" }}
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>
                        Set User ID
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id='changeinput'>
                        <input className='col-9' value={id} onChange={(e) => onchange(e)} ></input>
                        {!isValidId ?
                            doesIdExist ?
                                <small style={{ display: 'block' }} className='text-danger'>This id is already in use.</small>
                                :
                                <small style={{ display: 'block' }} className='text-danger'>Invalid id. Your id should be more than 4 characters</small>
                            :
                            <small style={{ display: 'block' }} className='text-success'>Valid id</small>

                        }
                        <small style={{ display: 'block' }}>Enter an id for your showcase. This acts as the url for your link showcase.
                        {isValidId ? <div className="text-info">https://www.linkshowcase.com/{id}</div> : <div></div>}
                            <div className='text-danger' >This cannot be changed later</div></small>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    {doesIdExist || !isValidId ?
                        < Button type='submit' variant="primary disabled">SetId</Button>
                        :
                        <Button type='submit' form='changeinput' onClick={e => submit(e)} variant="primary">SetId</Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SetUserId
